<template>
    <v-dialog v-model="getModalCadastroUnidadeMedida" max-width="720">
        <v-card>
            <v-card-title>Cadastro de Unidade de Medida</v-card-title>
            <v-form class="px-3" ref="formUnidadeMedida">
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 md12>
                            <v-text-field class="mr-2 ml-2" dense outlined v-model="getUnidadeMedida.unidade"
                                label="Unidade de Medida" :rules="rules.unidade" >
                            </v-text-field>
                        </v-flex>

                        <v-flex xs12 md12>
                            <v-text-field class="mr-2 ml-2" dense outlined v-model="getUnidadeMedida.descricao"
                                label="Descrição" :rules="rules.descricao" @keyup.13="salvar">
                            </v-text-field>
                        </v-flex>
                        
                        <v-flex xs12 md12>
                            <v-checkbox class="mr-2 ml-2" dense outlined v-model="getUnidadeMedida.permite_fracionamento"
                                label="Permitir Fracionamento">
                            </v-checkbox>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn outlined color="default" @click="setModalCadastroUnidadeMedida(false)">Voltar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn outlined color="success" @click="salvar">Salvar</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>
<script>
    import {mapGetters, mapActions} from 'vuex'
    export default {
        data(){
            return {
                rules: {
                    unidade: [
                        v => !!v || 'Campo obrigatório'
                    ],
                    descricao: [
                        v => !!v || 'Campo obrigatório.'
                    ]
                }
            }
        },
        computed: {
            ...mapGetters([
                'getUnidadeMedida',
                'getModalCadastroUnidadeMedida',
            ])
        },
        methods: {
            ...mapActions([
                'setModalCadastroUnidadeMedida',
                'salvarUnidadeMedida',
                'atualizarUnidadeMedida'
            ]),
            salvar(){
                if(this.$refs.formUnidadeMedida.validate()){
                    if(this.getUnidadeMedida.id){
                        this.atualizarUnidadeMedida(this.getUnidadeMedida)
                    }else{
                        this.salvarUnidadeMedida(this.getUnidadeMedida)
                    }
                }
            }
        }
    }
</script>